module.exports = require('./components/Modal');




//////////////////
// WEBPACK FOOTER
// /var/www/build-health-2/~/react-modal/lib/index.js
// module id = 421
// module chunks = 0